import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Trash2, Lock, EyeOff } from "lucide-react";
import { MarianneHeader } from "../components/MarianneHeader";

const POINTS = [
  { icon: Trash2, title: "Vos documents sont supprimés", text: "Votre photo ou PDF est analysé puis immédiatement supprimé de nos serveurs. Nous n'en gardons aucune copie." },
  { icon: EyeOff, title: "Aucune revente de données", text: "Vos courriers et vos données personnelles ne sont jamais vendus, partagés ni utilisés à des fins publicitaires." },
  { icon: Lock, title: "Sans compte, sans traçage", text: "Vous pouvez utiliser Marianne sans créer de compte. Nous ne mesurons qu'un nombre anonyme de scans, rien d'identifiant." },
  { icon: ShieldCheck, title: "Conforme au RGPD", text: "Marianne respecte le Règlement Général sur la Protection des Données. Le minimum de données, pour le maximum d'aide." },
];

export default function Confidentialite() {
  const navigate = useNavigate();
  return (
    <div className="marianne-shell flex flex-col">
      <MarianneHeader onLogoClick={() => navigate("/")} />
      <div className="px-5 pt-5 pb-10 flex-1 lg:max-w-3xl lg:mx-auto">
        <button onClick={() => navigate("/")} className="flex items-center gap-2 text-marianne font-medium mb-4" data-testid="privacy-back">
          <ArrowLeft className="w-5 h-5" /> Retour
        </button>
        <div className="flex items-center gap-3 mb-2">
          <ShieldCheck className="w-8 h-8 text-marianne-blue" />
          <h1 className="font-head text-2xl font-extrabold text-marianne">Confidentialité</h1>
        </div>
        <p className="text-lg text-gray-600 leading-relaxed mb-6">
          Un courrier administratif contient des informations sensibles. Voici notre promesse claire.
        </p>
        <div className="space-y-4">
          {POINTS.map((p, i) => (
            <div key={i} className="bg-white rounded-2xl border border-gray-100 p-5 shadow-[0_4px_24px_rgba(11,29,81,0.05)]" data-testid={`privacy-point-${i}`}>
              <div className="flex items-center gap-3 mb-1.5">
                <p.icon className="w-6 h-6 text-marianne" />
                <h2 className="font-head font-bold text-lg text-marianne">{p.title}</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
        <p className="text-sm text-gray-400 italic text-center mt-8">
          Marianne vous aide à comprendre, elle ne remplace pas un conseil juridique.
        </p>
      </div>
    </div>
  );
}
